/**
 * 超管判定：以后端/ JWT 显式字段为准，并兼容 permissions 含全局通配符 *。
 * 仅用于「是否超管」与双字段互相同步，不替代业务权限码列表（如 msorg:*）。
 */
export function resolveSuperAdminFlags(raw) {
    const explicit = raw.isSuperAdmin === true ||
        raw.is_super_admin === true ||
        raw.isSuperAdmin === "true" ||
        raw.is_super_admin === "true" ||
        raw.isSuperAdmin === 1 ||
        raw.is_super_admin === 1;
    const wildcard = Array.isArray(raw.permissions) && raw.permissions.includes("*");
    const roleSuper = Array.isArray(raw.roles) && raw.roles.includes("super_admin");
    const effective = explicit || wildcard || roleSuper;
    return { isSuperAdmin: effective, is_super_admin: effective };
}
export function isSuperAdminUser(user) {
    if (!user || typeof user !== "object")
        return false;
    return resolveSuperAdminFlags(user).isSuperAdmin;
}
